import {createContext, useCallback, useContext, useMemo, useState} from "react";
import { weatherStationService } from "../services/WeatherStationService";

export const WeatherStationContext = createContext();

export const WeatherStationProvider = props => {
    const [weatherStations, setWeatherStations] = useState([]);
    const [total, setTotal] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [pageIndex, setPageIndex] = useState(0);
    const [sortState, setSortState] = useState([{ fieldName: 'Name', dir: 'asc' }]);
    
    const queryWeatherStations = useCallback(async () => {
        const res = await weatherStationService.getWeatherStations(pageSize, pageIndex, sortState[0]?.fieldName, sortState[0]?.dir);
        
        setWeatherStations(res.data);
        setTotal(res.total);
    }, [pageSize, pageIndex, sortState]);
    
    const createWeatherStation = useCallback(
        (name, usaf, wban, icao) => {
            return weatherStationService.postWeatherStation(
                name,
                usaf,
                wban,
                icao
            );
        }, []
    );
    
    const getWeatherStationById = useCallback(
        (id) => {
            return weatherStationService.getWeatherStationById(id);
        }, []);
    
    const editWeatherStation = useCallback(
        (id, name, usaf, wban, icao) => {
        return weatherStationService.editWeatherStation(id, name, usaf, wban, icao);
    }, []);
    
    const deleteWeatherStation = useCallback(
        (id) => {
            return weatherStationService.deleteWeatherStation(id);
            }, 
        []);
    
    const values = useMemo(
        () => ({
            weatherStations,
            total,
            pageSize,
            setPageSize,
            pageIndex,
            setPageIndex,
            sortState,
            setSortState,
            queryWeatherStations,
            createWeatherStation,
            getWeatherStationById,
            editWeatherStation,
            deleteWeatherStation
        }), 
        [weatherStations, total, pageSize, pageIndex, sortState]
    );
    
    return (
        <WeatherStationContext.Provider value={values}>
            {props.children}
        </WeatherStationContext.Provider>
    );
}

export const useWeatherStation = () => {
    const context = useContext(WeatherStationContext);
    
    if (context === undefined) {
        throw new Error('useWeatherStation must be used within a WeatherStationProvider component');
    }
    
    return context;
};
